import { IRecipeBook } from "../../types/recipe";

export class RecipeBookDb {
  private dbName = "RecipeBookDB";
  private dbVersion = 2;
  private storeName = "recipeBook";

  async initDB(): Promise<void> {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(this.dbName, this.dbVersion);

      request.onerror = () => {
        reject(request.error);
      };

      request.onsuccess = () => {
        resolve();
      };

      request.onupgradeneeded = (event) => {
        const db = (event.target as IDBOpenDBRequest).result;
        if (!db.objectStoreNames.contains(this.storeName)) {
          db.createObjectStore(this.storeName, {
            keyPath: "id",
            autoIncrement: true,
          });
        }
      };
    });
  }

  async addRecipeBooks(recipe_books: IRecipeBook[], clear?: boolean): Promise<void> {
    const db = await this.getDB();
    const transaction = db.transaction(this.storeName, "readwrite");
    const store = transaction.objectStore(this.storeName);

    if (clear) {
      const clearRequest = store.clear();
      clearRequest.onsuccess = () => {
        console.log("cleared recipe books");
      };
    }

    return new Promise((resolve, reject) => {
      recipe_books.forEach((recipe_book) => {
        store.put(recipe_book);
      });

      transaction.oncomplete = () => {
        resolve();
      };

      transaction.onerror = () => {
        reject(transaction.error);
      };
    });
  }

  async getRecipeBooks(): Promise<IRecipeBook[]> {
    const db = await this.getDB();
    const transaction = db.transaction(this.storeName, "readonly");
    const store = transaction.objectStore(this.storeName);

    return new Promise((resolve, reject) => {
      const request = store.getAll();

      request.onsuccess = () => {
        resolve(request.result);
      };

      request.onerror = () => {
        reject(request.error);
      };
    });
  }

  private async getDB(): Promise<IDBDatabase> {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(this.dbName, this.dbVersion);

      request.onerror = () => {
        reject(request.error);
      };

      request.onsuccess = () => {
        resolve(request.result);
      };
    });
  }
}
